enum ExtraCoverageAccessor {
  GolfCartDamageAndLiabilityCoverage = "golfCarts.value",
  EnhancedCoverage = "enhancedCoverage.value",
  TripCollisionCoverage = "tripCollision.value",
  EarthquakeCoverage = "earthquake.value",
  VacationRentalCoverage = "vacationRental.value",
  WaterBackupCoverage = "waterBackupAndSumpOverflow.value",
  MineSubsidence = "mineSubsidence.value",
  MineSubsidenceScheduled = "mineSubsidenceScheduled.value",
  DebrisRemoval = "debrisRemoval.value",
  IdentityFraudExpense = "identityFraudExpense.value",
  LossAssessment = "lossAssessment.value",
  IncidentalFarming = "incidentalFarming.value",
  LandlordPersonalInjury = "landlordPersonalInjury.value",
  EquipmentBreakdown = "equipmentBreakdown.value",
  SinkholeCoverage = "sinkhole.value",
  ValuableItemProtection = "scheduledPersonalProperty.value",
  ResidenceBurglary = "residenceBurglary.value",
  RoofPaymentSchedule = "roofPaymentSchedule.value",
  BuildersRisk = "buildersRisk.value",
  SecondaryResidenceLiability = "secondaryResidenceLiability.value",
  VandalismOrMaliciousMischief = "vandalismOrMaliciousMischief.value",
  WindstormOrHailExclusion = "windstormOrHailExclusion.value",
  FortifiedRoofUpgrade = "fortifiedRoofUpgrade.value",
}

export { ExtraCoverageAccessor };
